/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StateOfGoods } from './StateOfGoods';
import {
    StateOfGoodsFromJSON,
    StateOfGoodsFromJSONTyped,
    StateOfGoodsToJSON,
    StateOfGoodsToJSONTyped,
} from './StateOfGoods';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';

/**
 * 
 * @export
 * @interface InsuranceDraft
 */
export interface InsuranceDraft {
    /**
     * 
     * @type {number}
     * @memberof InsuranceDraft
     */
    amount?: number;
    /**
     * 
     * @type {Currency}
     * @memberof InsuranceDraft
     */
    currency?: Currency;
    /**
     * 
     * @type {StateOfGoods}
     * @memberof InsuranceDraft
     */
    stateOfGoods?: StateOfGoods;
}



/**
 * Check if a given object implements the InsuranceDraft interface.
 */
export function instanceOfInsuranceDraft(value: object): value is InsuranceDraft {
    return true;
}

export function InsuranceDraftFromJSON(json: any): InsuranceDraft {
    return InsuranceDraftFromJSONTyped(json, false);
}

export function InsuranceDraftFromJSONTyped(json: any, ignoreDiscriminator: boolean): InsuranceDraft {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'currency': json['currency'] == null ? undefined : CurrencyFromJSON(json['currency']),
        'stateOfGoods': json['stateOfGoods'] == null ? undefined : StateOfGoodsFromJSON(json['stateOfGoods']),
    };
}

  export function InsuranceDraftToJSON(json: any): InsuranceDraft {
      return InsuranceDraftToJSONTyped(json, false);
  }

  export function InsuranceDraftToJSONTyped(value?: InsuranceDraft | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'currency': CurrencyToJSON(value['currency']),
        'stateOfGoods': StateOfGoodsToJSON(value['stateOfGoods']),
    };
}

